import { render } from "./OpenSalesOrdersTable.vue?vue&type=template&id=3903f12a&scoped=true"
import script from "./OpenSalesOrdersTable.vue?vue&type=script&lang=js"
export * from "./OpenSalesOrdersTable.vue?vue&type=script&lang=js"

import "./OpenSalesOrdersTable.vue?vue&type=style&index=0&id=3903f12a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3903f12a"]])

export default __exports__